import { Box, FormControl, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, } from '@mui/material';
import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate';
import Spinner from './spinner/spinner';
import { ConferenceSalutation } from '../constant/constant';
import { useGetAllRegisterMemberPaginationMutation, useGetMemberFeesByIdQuery } from '../app/services/conferenceService';
function EnhancedTableHead() {
    const headCells = [
        { id: "Full Name", numeric: false, disablePadding: true, label: "Full Name" },
        { id: "Member ID", numeric: false, disablePadding: true, label: "Member ID" },
        {
            id: "Email",
            numeric: true,
            disablePadding: false,
            label: "Email ID",
        },
        {
            id: "Mobile Number",
            numeric: true,
            disablePadding: false,
            label: "Mobile Number",
        },
        {
            id: "Registration Category",
            numeric: true,
            disablePadding: false,
            label: "Registration Category",
        },
        {
            id: "Payment Status",
            numeric: true,
            disablePadding: false,
            label: "Payment Status",
        },
    ];

    return (
        <>
            <TableHead>
                <TableRow className="menus-color">
                    {headCells.map((headCell) => (
                        <TableCell
                            sx={{ textAlign: "center", color: "#ffff", minWidth: headCell?.width ? headCell.width : 'auto' }}
                            key={headCell.id}
                            align={headCell.numeric ? "right" : "left"}
                            padding={headCell.disablePadding ? "none" : "normal"}
                        >
                            {headCell.label}
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        </>
    );
}
const GetCategoryName = ({ id }) => {
    const { data } = useGetMemberFeesByIdQuery(id, { refetchOnMountOrArgChange: true, skip: !id });
    return (
        <>
            <p>{data?.data?.categoryName}</p>
        </>
    )
}

const ConferenceMemberTable = () => {
    const [loading, setLoading] = useState(false);
    const [allMemberData, setAllMemberData] = useState([])
    const [page, setPage] = useState(0);
    const [totalPage, setTotalPage] = useState(2);
    const [searchTerm, setSearchTerm] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [error, setError] = useState("");
    const [getAllData] = useGetAllRegisterMemberPaginationMutation();

    useEffect(() => {
        const data = {
            page: page + 1,
            itemsPerPage: itemsPerPage
        }
        setLoading(true)
        getAllData(data).then(res => {
            setLoading(false)
            if (res?.data?.status) {
                setAllMemberData(res?.data?.data?.registrationDetails)
                setTotalPage(res?.data?.data?.totalCount)
            }
        })
    }, [getAllData, page, itemsPerPage])

    //page Click for event type
    const handlePageClick = ({ selected }) => {
        setSearchTerm('')
        setError("");
        setPage(selected);
    };
    const pageCount = Math.ceil(totalPage / itemsPerPage);

    const handlePageChange = () => {
        const pageNumber = Number(searchTerm);
        if (isNaN(pageNumber) || pageNumber < 0) {
            setError("Page number cannot be less than 1");
        } else if (pageNumber > pageCount) {
            setError("Please enter valid page number");
        } else if (pageNumber === 0) {
            setError("Please enter page number");
        } else {
            setError("");
            setPage(pageNumber - 1);
        }
    };
    return (
        <>
            <div className="pt-5">
                <div className="chapter-heading">
                    <h2 className="text-center title-font text-light py-3 mt-1">Conference Registered Members</h2>
                </div>
            </div>
            {loading ? (
                <Spinner />
            ) :
                <div className='p-md-5 p-3 overallPadding'>
                    <Box
                        className=""
                    >
                        <TableContainer component={Paper} sx={{ boxShadow: 0 }}>
                            <Table aria-labelledby="tableTitle">
                                <EnhancedTableHead />
                                <TableBody>
                                    {allMemberData?.length > 0 ? (
                                        allMemberData.map((member, index) => (
                                            <TableRow
                                                hover
                                                key={member._id}
                                                sx={{
                                                    cursor: "pointer",
                                                    backgroundColor: "white",
                                                }}
                                            >
                                                <TableCell align="center" >{ConferenceSalutation.find(i => i?.id === member?.Salutation)?.Name} {member.fullName}</TableCell>
                                                <TableCell align="center" >{member.memberId!==''?member.memberId:'-----'}</TableCell>
                                                <TableCell align="center" >{member.email}</TableCell>
                                                <TableCell align="center" >{member.mobileNumber}</TableCell>
                                                <TableCell align="center" ><GetCategoryName id={member?.registrationPlan} /></TableCell>
                                                <TableCell align="center" >{member.isPaid === 1 ?
                                                    <>
                                                        <span style={{color:'green',fontWeight:600}}>Paid</span>
                                                    </> : <>
                                                        <span style={{color:"rgb(118, 107, 203)",fontWeight:600}} >InProgress</span>
                                                    </>}
                                                </TableCell>
                                                {/* <TableCell
                                                    align="center" >
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        gap="8px"
                                                        flexWrap="wrap"
                                                    >
                                                        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                                                            {member?.isDeleted === 0 ? (
                                                                <Tooltip title="Enable" placement="top">
                                                                    <IconButton
                                                                        aria-label="enable"
                                                                        onClick={() => {
                                                                            handleEnableDisable(member._id);
                                                                        }}
                                                                    >
                                                                        <LockOpenIcon style={{ color: "green" }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            ) : member?.isDeleted === 2 ? (
                                                                <Tooltip title="Disable" placement="top">
                                                                    <IconButton
                                                                        aria-label="disable"
                                                                        onClick={() => {
                                                                            handleEnableDisable(member._id);
                                                                        }}
                                                                    >
                                                                        <LockIcon style={{ color: "red" }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            ) : null}
                                                        </div>
                                                    </Box>
                                                </TableCell> */}
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow sx={{
                                            cursor: "pointer",
                                            backgroundColor: "white",
                                        }}>
                                            <TableCell className='w-100' colSpan={5} align="center">
                                                No Data Available
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                                {/* <Modal
                                    open={open1}
                                    onClose={handleClose1}
                                    aria-labelledby="modal-modal-title"
                                    aria-describedby="modal-modal-description"
                                >
                                    <Grid sx={style1} container className='overflow-y-scroll' maxWidth={'sm'}>
                                        <Container maxWidth={false} sx={{ px: 3 }}>
                                            <Box className="d-flex justify-content-between pt-2">
                                                <Typography variant="h5" className="fw-bold" sx={{ color: "#0d4022 !important", fontWeight: "bold" }}>
                                                    View member Content
                                                </Typography>
                                                <IconButton onClick={handleClose1} aria-label="Close">
                                                    <CloseIcon />
                                                </IconButton>
                                            </Box>
                                        </Container>
                                        <Box display="flex" justifyContent="center" width="100%" className='mb-2'>
                                            <Divider className="black-line-for-modal mb-0" sx={{ width: "100%" }} />
                                        </Box>
                                        <Grid item xs={12} mb={3}>
                                            <h4 className='alata-regular title-font' style={{ color: "#611f1e" }} >Desktop member Image</h4>
                                            <img src={selectedmember?.desktopmemberImage} className='w-75 img-fluid' alt="" />
                                        </Grid>
                                        <Grid item xs={12} mb={3}>
                                            <h4 className='alata-regular title-font' style={{ color: "#611f1e" }}>Mobile member Image</h4>
                                            <img src={selectedmember?.mobilememberImage} className='w-75 img-fluid' alt="" />
                                        </Grid>
                                        <Grid item xs={12} mb={3}>
                                            <h4 className='alata-regular title-font' style={{ color: "#611f1e" }}>member Text Content</h4>
                                            <p className='alata-regular'>{selectedmember?.text}</p>
                                        </Grid>
                                        <Grid item xs={12} mb={3}>
                                            <h4 className='alata-regular title-font' style={{ color: "#611f1e" }}>Button Link</h4>
                                            <a className='alata-regular' href={selectedmember?.buttonLink}>{selectedmember?.buttonLink}</a>

                                        </Grid>

                                    </Grid>
                                </Modal>
                                <Modal
                                    open={open}
                                    onClose={handleClose}
                                    aria-labelledby="modal-modal-title"
                                    aria-describedby="modal-modal-description"
                                >
                                    <Box
                                        sx={style}
                                        className="d-flex  flex-column gap-3 overflow-x-hidden overflow-y-hidden"
                                    >

                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                            <Typography variant="h5" sx={{ color: "#0d4022", fontWeight: "bold" }}>
                                                Confirmation
                                            </Typography>
                                            <IconButton onClick={handleClose} aria-label="Close">
                                                <CloseIcon />
                                            </IconButton>
                                        </div>
                                        <Box display="flex" justifyContent="center" width="100%">
                                            <Divider className="black-line-for-modal mb-0" sx={{ width: "100%" }} />
                                        </Box>
                                        <Typography
                                            id="modal-modal-title"
                                            style={{ color: "#611f1e" }}
                                            variant="h6"
                                            component="h2"
                                            className="content-font"
                                        >
                                            Are You Surely Want to Delete this member?
                                        </Typography>
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <Button
                                                variant="outlined"
                                                className="content-font"
                                                style={{

                                                    color: "#dc3545",
                                                    border: "1px solid #dc3545",
                                                    padding: "5px 15px",
                                                    borderRadius: "0px",
                                                }}
                                                onClick={handleClose}
                                            >
                                                No
                                            </Button>
                                            <Button
                                                className="mx-2 content-font"
                                                variant="contained"
                                                style={{
                                                    backgroundColor: "#2e7d32",
                                                    color: "white",
                                                    padding: "5px 15px",
                                                    borderRadius: "0px",
                                                }}
                                                onClick={() => handleDelete()}
                                            >
                                                Yes
                                            </Button>
                                        </div>
                                    </Box>
                                </Modal> */}
                            </Table>
                        </TableContainer>

                        <br />
                        {allMemberData.length > 0 ? (
                            <div className="d-flex justify-content-between flex-md-row flex-column gx-3 gx-md-0 content-font" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px", marginBottom: "56px" }}>
                                <div className="mb-2 mb-md-0">
                                    <div className="d-flex gap-2">
                                        <input
                                            type="number"
                                            min={1}
                                            placeholder="Page no."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            className="search-input"
                                        />
                                        <div className="goPage cursor-pointer" onClick={handlePageChange}>
                                            <h5 className="p-2 m-0">Go</h5>
                                        </div>
                                    </div>
                                    {error && <p style={{ color: "red", fontSize: "14px" }}>{error}</p>}
                                </div>

                                {/* Pagination in the Center */}
                                <div className="my-3 my-md-0">
                                    <ReactPaginate
                                        pageCount={pageCount} // Calculate total pages
                                        pageRangeDisplayed={1}
                                        marginPagesDisplayed={1}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination"}
                                        activeClassName={"active"}
                                        previousLabel={pageCount > 1 && page >= 1 ? "Previous" : null}
                                        nextLabel={pageCount > 1 && page + 1 !== pageCount ? "Next" : null}
                                        disabledClassName={"disablebtn"}
                                        forcePage={page}
                                    />
                                </div>
                                <div className="mb-2 mb-md-0">
                                    <FormControl variant="outlined">
                                        <Select
                                            className="itemsperpage"
                                            value={itemsPerPage}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setItemsPerPage(value);
                                                setError('')
                                                setSearchTerm('');
                                                setPage(0)
                                            }}
                                            MenuProps={{
                                                MenuListProps: {
                                                    sx: {
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                    },
                                                },
                                            }}
                                        >
                                            <MenuItem value={10} className="Event-menu">10</MenuItem>
                                            <MenuItem value={20} className="Event-menu">20</MenuItem>
                                            <MenuItem value={50} className="Event-menu">50</MenuItem>
                                            <MenuItem value={100} className="Event-menu">100</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                        ) : (
                            <></>
                        )}
                    </Box>
                    <br />
                </div >
            }
        </>
    )
}

export default ConferenceMemberTable